<template lang="pug">
.curso-main-container.pb-3
  BannerInterno(icono="fas fa-tasks" titulo="Actividad didáctica")
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
</template>

<script>
export default {
  name: 'Actividad',
}
</script>

<style lang="sass"></style>
